<template lang="pug">
div
  y-dialog(v-if="showDialog" v-model="showDialog" persistent fullscreen scrollable)
    v-card.neutral200
      div.d-flex.justify-center.mt-16(v-if="isFetching")
        v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
      template(v-else)
        v-card-text.neutral700--text.pa-8(outlined)
          v-row(justify="center")
            v-col(cols="9")
              div.d-flex.align-center.mb-6
                v-btn.mr-2(icon color="neutral700" @click="closeDialog")
                  v-icon(color="neutral700" :size="24") mdi-arrow-left
                .text-2xl.font-semibold(v-if="blastData.type === 'first_purchase'") First Visit
                .text-2xl.font-semibold(v-if="blastData.type === 'second_purchase'") Second Visit
                .text-2xl.font-semibold(v-if="blastData.type === 'reactivation'") Reactivation
              v-form(ref="form")
                //- SMS
                v-card.round-xl.content-box.pa-6(outlined)
                  v-row(align="center")
                    v-col(cols="2")
                      div.d-flex.align-center
                        v-icon.mr-3(size="20" color="neutral500") $yzi-message-square-02
                        div.text-md.font-semibold.neutral700--text SMS
                    v-col
                      div
                        div.text-xs.font-semibold.neutral700--text Offer will be sent:
                        div.text-xs.neutral700--text(v-if="method.sms") {{ method.sms.auto_send_delay_time_value }} {{ method.sms.auto_send_delay_time_unit }} after registration
                        div.text-xs.neutral500--text(v-else) Not set

                    v-col.shrink
                      div
                        y-switch.mb-n3(v-model="methodSwitch.sms" :disabled="!method.sms" @change="changeActivationMethod('sms', methodSwitch.sms)")

                  v-card.round-xl.pa-6.mt-4(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
                    v-row(dense align="center")
                      v-col.grow
                        div.d-flex.align-center
                          v-avatar.mr-2(size="8" :color="method.sms ? 'success500' : 'blue500'")
                          div.text-sm.font-medium.neutral700--text(v-if="blastData.type === 'first_purchase'") First visit message
                          div.text-sm.font-medium.neutral700--text(v-if="blastData.type === 'second_purchase'") Second visit message
                          div.text-sm.font-medium.neutral700--text(v-if="blastData.type === 'reactivation'") Reactivation message
                      v-col(align="right" cols="5")
                        y-button(label="View & edit" size="sm" outlined @click="openDeliveranceDialog('sms')")
                        y-button.ml-3(v-if="method.sms" label="Send test message" size="sm" @click="openTestDialog('sms')")

                //- whatsapp
                v-card.round-xl.content-box.pa-6.mt-4(outlined)
                  v-row(align="center")
                    v-col(cols="2")
                      div.d-flex.align-center
                        v-icon.mr-3(size="20" color="neutral500") mdi-whatsapp
                        div.text-md.font-semibold.neutral700--text WhatsApp
                    v-col
                      div
                        div.text-xs.font-semibold.neutral700--text Offer will be sent:
                        div.text-xs.neutral700--text(v-if="method.whatsapp") {{ method.whatsapp.auto_send_delay_time_value }} {{ method.whatsapp.auto_send_delay_time_unit }} after registration
                        div.text-xs.neutral500--text(v-else) Not set

                    v-col.shrink
                      div
                        y-switch.mb-n3(v-model="methodSwitch.whatsapp" :disabled="!method.whatsapp" @change="changeActivationMethod('whatsapp', methodSwitch.whatsapp)")

                  v-card.round-xl.pa-6.mt-4(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
                    v-row(dense align="center")
                      v-col.grow
                        div.d-flex.align-center
                          v-avatar.mr-2(size="8" :color="method.whatsapp ? 'success500' : 'blue500'")
                          div.text-sm.font-medium.neutral700--text(v-if="blastData.type === 'first_purchase'") First visit message
                          div.text-sm.font-medium.neutral700--text(v-if="blastData.type === 'second_purchase'") Second visit message
                          div.text-sm.font-medium.neutral700--text(v-if="blastData.type === 'reactivation'") Reactivation message
                      v-col(align="right" cols="5")
                        y-button(label="View & edit" size="sm" outlined @click="openDeliveranceDialog('whatsapp')")
                        y-button.ml-3(v-if="method.whatsapp" label="Send test message" size="sm" @click="openTestDialog('whatsapp')")

                //- email
                v-card.round-xl.content-box.pa-6.mt-4(outlined)
                  v-row(align="center")
                    v-col(cols="2")
                      div.d-flex.align-center
                        v-icon.mr-3(size="20" color="neutral500") $yzi-mail-01
                        div.text-md.font-semibold.neutral700--text Email
                    v-col
                      div
                        div.text-xs.font-semibold.neutral700--text Offer will be sent:
                        div.text-xs.neutral700--text(v-if="method.email") {{ method.email.auto_send_delay_time_value }} {{ method.email.auto_send_delay_time_unit }} after registration
                        div.text-xs.neutral500--text(v-else) Not set

                    v-col.shrink
                      div
                        y-switch.mb-n3(v-model="methodSwitch.email" :disabled="!method.email" @change="changeActivationMethod('email', methodSwitch.email)")

                  v-card.round-xl.pa-6.mt-4(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
                    v-row(dense align="center")
                      v-col.grow
                        div.d-flex.align-center
                          v-avatar.mr-2(size="8" :color="method.email ? 'success500' : 'blue500'")
                          div.text-sm.font-medium.neutral700--text(v-if="blastData.type === 'first_purchase'") First visit email
                          div.text-sm.font-medium.neutral700--text(v-if="blastData.type === 'second_purchase'") Second visit email
                          div.text-sm.font-medium.neutral700--text(v-if="blastData.type === 'reactivation'") Reactivation email
                        div.text-sm.neutral700--text.mt-2(v-if="method.email && method.email.subject") {{ method.email.subject }}
                      v-col(align="right" cols="5")
                        y-button(label="View & edit" size="sm" outlined @click="openDeliveranceDialog('email')")
                        y-button.ml-3(v-if="method.whatsapp" label="Send test email" size="sm" @click="openTestDialog('email')")
                
                v-card.round-xl.content-box.pa-6.mt-4(outlined)
                  div.d-flex.align-center
                    div()
                      div.text-md.font-semibold.neutral700--text Reward customer that register to loyalty points program on {{ getText }}
                      div.text-sm.neutral700--text You will reward your customer who registers on their {{ getText }}
                    v-spacer
                    div
                      y-switch.mb-n3(v-model="rewardStatus")

                  //- Applies to
                  div.text-md.font-semibold.neutral700--text.mt-8 Applies to
                  v-row(no-gutters)
                    v-col(cols="6")
                      v-radio-group.mt-0(v-model="blast.upon_any_purchase" @change="sanitizeUnusedObject(null,['purchase_products'])")
                        v-radio.mt-3(:value="true" color="neutral700")
                          template(v-slot:label)
                            div.text-md.font-medium.neutral700--text All inventory & services
                        v-radio.mt-3(:value="false" color="neutral700" style="align-items: unset;")
                          template(v-slot:label)
                            div.text-md.font-medium.neutral700--text Specific inventory & services
                  template(v-if="blast.hasOwnProperty('upon_any_purchase') && !blast.upon_any_purchase")
                    inventory-services-selection(v-model="blast.purchase_products")

                  //- Offers reward
                  div.text-md.font-semibold.neutral700--text.mt-8 Offers reward
                  .text-sm.neutral700--text(style="margin-top: 2px;") Setup your offers reward
                  v-radio-group.mt-0(v-model="blast.reward_type" @change="sanitizeUnusedObject(['discount_percentage', 'discount_amount', 'free_item_type', 'free_item_name'], ['free_products'])")
                    v-row(no-gutters)
                      v-col(cols="6")
                        v-radio.mt-3(value="discount_percentage" color="neutral700")
                          template(v-slot:label)
                            div
                              div.text-md.font-medium.neutral700--text Percentage discount (%)
                              div.text-sm.font-normal.neutral700--text Make a discount based on percentage of the full price
                        template(v-if="blast.reward_type && blast.reward_type === 'discount_percentage'")
                          v-text-field.text-sm.mt-2.round-xl.pl-8(v-model="blast.discount_percentage" placeholder="0.0" outlined dense height="48" :rules="rules.not_empty" suffix="%" type="number" hide-details="auto")
                    v-row(no-gutters)
                      v-col(cols="6")
                        v-radio.mt-3(value="discount_amount" color="neutral700")
                          template(v-slot:label)
                            div
                              div.text-md.font-medium.neutral700--text Fixed amount discount (RM)
                              div.text-sm.font-normal.neutral700--text Make a discount based on a fixed amount
                        template(v-if="blast.reward_type && blast.reward_type === 'discount_amount'")
                          v-text-field.text-sm.mt-2.round-xl.pl-8(v-model="blast.discount_amount" placeholder="0.00" outlined dense height="48" :rules="rules.not_empty" :prefix="$currency.symbol" type="number" hide-details="auto")
                    v-row(no-gutters)
                      v-col(cols="6")
                        v-radio.mt-3(value="free_item" color="neutral700")
                          template(v-slot:label)
                            div
                              div.text-md.font-medium.neutral700--text Free
                              div.text-sm.font-normal.neutral700--text Give free inventory/services/visit/other item
                    v-row(no-gutters)
                      v-col(cols="10")
                        template(v-if="blast.reward_type && blast.reward_type === 'free_item'")
                          div.ml-8
                            v-row
                              v-col(cols="6")
                                y-select.mt-2(v-model="blast.free_item_type" placeholder="Select reward" attach :items="[{ text: 'Applied inventory and services', value: 'product' }, { text: 'Visit', value: 'visit' }, { text: 'Other item', value: 'other' }]" item-text="text" item-value="value" :rules="rules.not_empty_select" @change="sanitizeUnusedObject(['free_item_name'], ['free_products'])")
                              v-col(v-if="blast.free_item_type && blast.free_item_type === 'other'")
                                v-text-field.text-sm.mt-2.round-xl(v-model="blast.free_item_name" placeholder="Enter item name" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
                    div.ml-8(v-if="blast.reward_type && blast.reward_type === 'free_item' && blast.free_item_type && blast.free_item_type === 'product'")
                      inventory-services-selection(v-model="blast.free_products")

                  //- How to redeem
                  v-row.mt-5
                    v-col(cols="6")
                      div.text-md.font-semibold.neutral700--text How to redeem
                      div.text-sm.neutral700--text(style="margin-top: 2px;") Set on how your customer will redeem this offer
                      v-radio-group.mt-0(v-model="blast.redeem_method" @change="sanitizeUnusedObject(['coupon_code'])")
                        v-radio.mt-3(value="show_message" color="neutral700")
                          template(v-slot:label)
                            div.text-md.font-medium.neutral700--text Show message at counter
                        v-radio.mt-3(value="general_code" color="neutral700" style="align-items: unset;")
                          template(v-slot:label)
                            div.text-md.font-medium.neutral700--text Create general coupon code
                        template(v-if="blast.redeem_method && blast.redeem_method === 'general_code'")
                          v-text-field.text-sm.mt-2.round-xl.pl-8(v-model="blast.coupon_code" placeholder="Enter your code here" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
                        v-radio.mt-3(value="unique_code" color="neutral700")
                          template(v-slot:label)
                            div.text-md.font-medium.neutral700--text Generate unique coupon code for every customer

                //- Expiry duration
                v-card.round-xl.content-box.pa-6.mt-4(outlined)
                  div.text-md.font-semibold.neutral700--text Expiry duration
                  div.text-sm.neutral700--text(style="margin-top: 2px;") Set active period for this offer
                  v-row.mt-5(dense)
                    v-col(cols="2")
                      v-text-field.text-sm.round-xl(v-model="blast.end_after_value" placeholder="Enter value" outlined dense height="48" type="number" :rules="rules.not_empty" hide-details="auto")
                    v-col(cols="2")
                      y-select(v-model="blast.end_after_unit" placeholder="Select duration" attach menuPosition="top" :items="duration" item-text="text" item-value="value" :rules="rules.not_empty_select" @change="sanitizeUnusedObject(['free_item_name'], ['free_products'])")
                    v-col(cols="2")
                      div.text-md.neutral700--text.mt-3 after offer sent
                                
        v-divider
        v-card-actions.py-4.px-8.white
          v-spacer
          y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="closeDialog")
          y-button(label="Save" text-color="neutral100" color="neutral700" size="sm" dark :loading="isLoading" @click="saveData")

  .dialogs
    sms-preset-deliverance-dialog(v-if="openSmsDialog" :open.sync="openSmsDialog" :blast-data="selectedData" :offer="blastData" @closed="closed" @updated="reset")
    email-preset-deliverance-dialog(v-if="openEmailDialog" :open.sync="openEmailDialog" :blast-data="selectedData" :offer="blastData" @closed="closed" @updated="reset")
    whatsapp-preset-deliverance-dialog(v-if="openWhatsappDialog" :open.sync="openWhatsappDialog" :blast-data="selectedData" :offer="blastData" @closed="closed" @updated="reset")
    send-test-sms-dialog(v-if="openTestSmsDialog" :open.sync="openTestSmsDialog" :blast-data="selectedData" @closed="closed")
    send-test-email-dialog(v-if="openTestEmailDialog" :open.sync="openTestEmailDialog" :blast-data="selectedData" @closed="closed")
    send-test-whatsapp-dialog(v-if="openTestWhatsappDialog" :open.sync="openTestWhatsappDialog" :blast-data="selectedData" @closed="closed")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InventoryServicesSelection from '@/components/clinic/marketing/InventoryServicesSelection.vue'
import SmsPresetDeliveranceDialog from '@/components/clinic/marketing/dialogs/SmsPresetDeliveranceDialog.vue'
import EmailPresetDeliveranceDialog from '@/components/clinic/marketing/dialogs/EmailPresetDeliveranceDialog.vue'
import WhatsappPresetDeliveranceDialog from '@/components/clinic/marketing/dialogs/WhatsappPresetDeliveranceDialog.vue'
import SendTestSmsDialog from '@/components/clinic/marketing/dialogs/SendTestSmsDialog.vue'
import SendTestEmailDialog from '@/components/clinic/marketing/dialogs/SendTestEmailDialog.vue'
import SendTestWhatsappDialog from '@/components/clinic/marketing/dialogs/SendTestWhatsappDialog.vue'
import DatePickerField from '@/components/clinic/marketing/DatePickerField.vue'

export default {
  components: { InventoryServicesSelection, SmsPresetDeliveranceDialog, EmailPresetDeliveranceDialog, WhatsappPresetDeliveranceDialog, SendTestSmsDialog, SendTestEmailDialog, SendTestWhatsappDialog, DatePickerField },
  props: {
    open: {
      type: Boolean,
    },
    blastData: {
      type: Object,
      default: null
    },
  },
  data () {
    return {
      isFetching: false,
      isLoading: false,
      openSmsDialog: false,
      openEmailDialog: false,
      openWhatsappDialog: false,
      openTestSmsDialog: false,
      openTestWhatsappDialog: false,
      openTestEmailDialog: false,
      selectedData: null,
      method: {},
      methodSwitch: {},
      blast: {},
      duration: [
        { text: 'Hours', value: 'hours'},
        { text: 'Days', value: 'days'},
        { text: 'Weeks', value: 'weeks'},
        { text: 'Months', value: 'months'},
      ],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    rewardStatus: {
      get () {
        return Boolean(this.blast?.status === 'active')
      },
      set (val) {
        if (val) {
          this.blast.status = 'active'
        } else {
          this.blast.status = 'draft'
        }
      }
    },
    contentLength() {
      let text = this.blast?.content
      if (text) {
        text = text.replace(/{{ offer_code }}/g, "xxxx")
      }
      const length = text ? text.length : 0;
      const charLength = 155 - Number(this.setting?.sms_header?.length || 0)
      const numSMS = Math.ceil(length / charLength);
      const cost = numSMS * 0.2
      return { length, numSMS, cost };
    },
    getText () {
      let text = ''
      if (this.blastData.type === 'first_purchase') text = 'first visit'
      if (this.blastData.type === 'second_purchase') text = 'second visit'
      if (this.blastData.type === 'reactivation') text = 'reactivation'
      return text
    }
  },
  mounted () {
    this.fetchDeliveranceBlast()
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      if (this.blastData) {
        let blast = JSON.parse(JSON.stringify(this.blastData))
        if (blast.discount_amount) {
          blast.discount_amount = Number(blast.discount_amount) / this.$currency.multiplier
        }
        this.blast = blast
      }
    },
    fetchDeliveranceBlast () {
      this.isFetching = true
      this.$axios.get(`/loyalty/${this.company.slug}/offers/${this.blastData.id}/blasts`)
        .then(resp => {
          let blasts = resp.data.results
          if (blasts.find(f => f.method === 'sms')) {
            let data = blasts.find(f => f.method === 'sms')
            this.$set(this.method, 'sms', data)
            this.$set(this.methodSwitch, 'sms', data.enabled)
          }
          if (blasts.find(f => f.method === 'email')) {
            let data = blasts.find(f => f.method === 'email')
            this.$set(this.method, 'email', data)
            this.$set(this.methodSwitch, 'email', data.enabled)
          }
          if (blasts.find(f => f.method === 'whatsapp')) {
            let data = blasts.find(f => f.method === 'whatsapp')
            this.$set(this.method, 'whatsapp', data)
            this.$set(this.methodSwitch, 'whatsapp', data.enabled)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    changeActivationMethod (method, enabled) {
      let id = this.method[method]?.id
      if (id) {
        this.$axios.patch(`/loyalty/${this.company.slug}/offers/${this.blastData.id}/blasts/${id}`, { enabled })
          .then(() => {
            this.showMessage(['success', this.$t('success_message.successfully_updated')])
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
      }
    },
    sanitizeUnusedObject (strings, arrays) {
      if (strings && strings.length) {
        strings.forEach(f => {
          if (this.blast[f]) this.blast[f] = null
        })
      }
      if (arrays && arrays.length) {
        arrays.forEach(o => {
          if (this.blast[o]) this.blast[o] = []
        })
      }
    },
    openDeliveranceDialog (type) {
      if (type === 'sms') {
        if (this.method.sms) {
          this.selectedData = this.method.sms
        }
        this.openSmsDialog = true
      } else if (type === 'email') {
        if (this.method.email) {
          this.selectedData = this.method.email
        }
        this.openEmailDialog = true
      } else if (type === 'whatsapp') {
        if (this.method.whatsapp) {
          this.selectedData = this.method.whatsapp
        }
        this.openWhatsappDialog = true
      }
    },
    openTestDialog (type) {
      if (type === 'sms') {
        if (this.method.sms) {
          this.selectedData = this.method.sms
        }
        this.openTestSmsDialog = true
      } else if (type === 'email') {
        if (this.method.email) {
          this.selectedData = this.method.email
        }
        this.openTestEmailDialog = true
      } else if (type === 'whatsapp') {
        if (this.method.whatsapp) {
          this.selectedData = this.method.whatsapp
        }
        this.openTestWhatsappDialog = true
      }
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      this.isLoading = true
      let payload = {
        status: this.blast.status,
        upon_any_purchase: this.blast.upon_any_purchase,
        reward_type: this.blast.reward_type,
        discount_percentage: this.blast.discount_percentage,
        discount_amount: this.blast.discount_amount ? Math.round(Number(this.blast.discount_amount) * this.$currency.multiplier) : null,
        free_item_type: this.blast.free_item_type,
        redeem_method: this.blast.redeem_method,
        coupon_code: this.blast.coupon_code,
        end_after_value: this.blast.end_after_value,
        end_after_unit: this.blast.end_after_unit,
      }
      payload.purchase_products = this.blast.purchase_products.map(m => m.id)
      payload.free_products = this.blast.free_products.map(m => m.id)
      this.$axios.patch(`/loyalty/${this.company.slug}/offers/${this.blast.id}`, payload)
        .then(() => {
          this.$emit('updated')
          this.closeDialog()
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    reset () {
      this.fetchDeliveranceBlast()
    },
    closed () {
      this.selectedData = null
    },
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-data-table__wrapper table tbody tr:hover{
    cursor: pointer;
    background: var(--v-neutral200) !important; 
  }
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .search-field {
    .v-input__append-inner {
      margin-top: 12px !important;
    }
  }
}
</style>